// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__13z-P","footer":"ModalUpdate_footer__1aC-C"};